/**
 * Avatar URL helper
 *
 * Builds the avatar image URL for a user. On localhost, uses the dev-server
 * proxy so requests are same-origin and avoid net::ERR_BLOCKED_BY_ORB.
 */

const AVATAR_CDN_PROD = 'https://lore-avatars.lorehealthcare.io';
const AVATAR_CDN_NONPROD = 'https://lore-avatars-nonprod.lorehealthcare.io';

/**
 * Returns the base URL for avatar images (CDN or proxy).
 * In development, uses /avatar-proxy so the dev server proxies to the CDN (avoids net::ERR_BLOCKED_BY_ORB).
 */
function getAvatarBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const useProxy =
      process.env.REACT_APP_USE_AVATAR_PROXY === 'true' ||
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host === '::1' ||
      window.location.origin.includes('localhost') ||
      window.location.origin.includes('127.0.0.1');
    if (useProxy) {
      return `${window.location.origin}/avatar-proxy`;
    }
  }
  const env = process.env.REACT_APP_ENV || 'development';
  const isProd = env === 'prod' || env === 'production';
  return process.env.REACT_APP_AVATAR_CDN || (isProd ? AVATAR_CDN_PROD : AVATAR_CDN_NONPROD);
}

/**
 * Returns the full avatar image URL for a user by sso_object_id, or null if no id.
 */
export function getAvatarUrl(ssoObjectId: string | null | undefined, cacheBust = true): string | null {
  if (!ssoObjectId) return null;
  const base = getAvatarBaseUrl();
  const qs = cacheBust ? `?v=${Date.now()}` : '';
  return `${base}/${ssoObjectId}.jpeg${qs}`;
}
